import styled from "@emotion/styled";
import { useMantineColorScheme } from "@mantine/core";

export const LeftSpace = () => {
  const { colorScheme } = useMantineColorScheme();
  return <LeftSpaceContainer theme={{ colorScheme }} />;
};

const LeftSpaceContainer = styled.span<{ theme: { colorScheme: "dark" | "light" } }>`
  width: 32px;
  align-self: stretch;
  background: ${({ theme }) =>
    theme.colorScheme === "dark" ? "var(--gray-9, #212529)" : "var(--gray-2, #f8f9fa)"};
  border-bottom: ${({ theme }) =>
      theme.colorScheme === "dark" ? "var(--gray-9, #212529)" : "var(--gray-2, #f8f9fa)"}
    solid 1px;
  opacity: 0.2;
`;
